@if (spinnerService.isRequesting()) {
  <div class="spinner-container">
    <span class="spinner">
      <mat-spinner color="accent"></mat-spinner>
    </span>
  </div>
}
